import Cookies from 'js-cookie';
import { axios } from 'lib/axios';

export const confirmIdentity = (data) => {
  const token = Cookies.get('token');

  console.log(token);
  //  set token in the header
  return axios.post(
    '/user/authenticator/verifySensitive',
    {
      authenticatorCode: data.authenticatorCode,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
